import type { ModalConfig } from "./types";

export const contractModalsModalUrlConfig = {
  // Contract Modals (e-signature documents)
  "contracts-detail": {
    modalId: "contracts-detail",
    entityName: "contracts",
    singularParam: "contractId",
    pluralParam: "contractsId",
    displayName: "Contract",
  },
} as const satisfies Record<string, ModalConfig>;
